/**
 * A collection of commonly used input and data types.
 * These types are used to standardize the usage of input fields, API payloads, and other data structures across the application.
 *
 * @namespace TYPES
 */
export const TYPES = {
    /**
     * Represents an email input type.
     * Used for fields that require email addresses.
     *
     * @type {string}
     */
    EMAIL: "email",

    /**
     * Represents a password input type.
     * Used for fields that require secure password entry.
     *
     * @type {string}
     */
    PASSWORD: "password",

    /**
     * Represents a telephone input type.
     * Used for fields that require phone numbers.
     *
     * @type {string}
     */
    TEL: "tel",

    /**
     * Represents a text input type.
     * Used for fields that require plain text input.
     *
     * @type {string}
     */
    TEXT: "text",

    /**
     * Represents a phone input type.
     * Alias for `TEL`, used for fields that require phone numbers.
     *
     * @type {string}
     */
    PHONE: "phone",

    /**
     * Represents a button input type.
     * Used for clickable buttons in forms or UI elements.
     *
     * @type {string}
     */
    BUTTON: "button",

    /**
     * Represents a checkbox input type.
     * Used for fields that require binary selection (checked/unchecked).
     *
     * @type {string}
     */
    CHECKBOX: "checkbox",

    /**
     * Represents a number input type.
     * Used for fields that require numeric input.
     *
     * @type {string}
     */
    NUMBER: "number",

    /**
     * Represents a submit input type.
     * Used for form submission buttons.
     *
     * @type {string}
     */
    SUBMIT: "submit",

    /**
     * Represents an object data type.
     * Used for structured data or API payloads.
     *
     * @type {string}
     */
    OBJECT: "object",

    /**
     * Represents an error state.
     * Used to indicate an error in input validation or API responses.
     *
     * @type {string}
     */
    ERROR: "error",

    /**
     * Represents an active state.
     * Used to indicate an active status in UI components or API responses.
     *
     * @type {string}
     */
    ACTIVE: "active",

    /**
     * Represents an inactive state.
     * Used to indicate an inactive status in UI components or API responses.
     *
     * @type {string}
     */
    INACTIVE: "inactive",

    /**
     * Represents a role type.
     * Used for defining user roles in authentication or authorization systems.
     *
     * @type {string}
     */
    ROLE: "role", 

    /** @constant {string} AVAILABLE - Represents an available state for general use cases. */
    AVAILABLE: "Available"


}
